export default "<payment-partners\n  model=\"vm.model.acceptDebitsCertainBlackOrWhiteList\"\n  form=\"vm.form\">\n</payment-partners>\n";